module.exports = __webpack_public_path__ + "static/media/webuser.7cbaf51b.png";